<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ 'USER.INFO' | translate }}</h3>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <img style="max-width: 200px" [src]="photoURL" />
      </div>
      <div class="col-lg-8">
        <dl class="row">
          <dt class="col-sm-3 py-2">{{ 'USER.NAME' | translate }}</dt>
          <dd class="col-sm-9 py-2">{{ user.firstName }} {{ user.lastName }}</dd>

          <dt class="col-sm-3 py-2">{{ 'USER.EMAIL' | translate }}</dt>
          <dd class="col-sm-9 py-2">{{ user.email }}</dd>

          <dt class="col-sm-3 py-2">{{ 'USER.USERNAME' | translate }}</dt>
          <dd class="col-sm-9 py-2">{{ user.userName }}</dd>

          <dt class="col-sm-3 py-2">{{ 'USER.COMPANY' | translate }}</dt>
          <dd class="col-sm-9 py-2">
            {{ data?.company?.id }}-{{
              data?.currentCompany ? data.currentCompany : data?.company?.name
            }}
          </dd>

          <dt class="col-sm-3 py-2">{{ 'USER.STATUS' | translate }}</dt>
          <dd class="col-sm-9 py-2">
            <span
              class="label label-lg label-light-{{
                getItemCssClassByStatus(user.isActive)
              }} label-inline"
              >{{ getItemStatusString(user.isActive) }}</span
            >
          </dd>
        </dl>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>{{ 'TABLE.CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
